<template>
  <div>
    <section class="py-5 bg-light">
      <div class="container">
        <div class="row justify-content-md-center">
          <strong>店家位置</strong>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d319.42189779848366!2d121.50154676867801!3d25.07320011399403!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a92ff46080f1%3A0x9532236133e672f8!2zMjXCsDA0JzIzLjciTiAxMjHCsDMwJzA1LjQiRQ!5e0!3m2!1szh-TW!2stw!4v1581971907829!5m2!1szh-TW!2stw"
            width="100%"
            height="450"
            frameborder="0"
            style="border:0;"
            allowfullscreen
          ></iframe>

          <ul class="list-group mt-3 display-4">
            <a class="list-group-item" href="https://www.facebook.com/tomone1202/">
              <small>
                <i class="fab fa-facebook"></i>
                Facebook
              </small>
            </a>
            <a class="list-group-item" href="https://www.instagram.com/red_1202/">
              <small>
                <i class="fab fa-instagram"></i>
                Instagram
              </small>
            </a>
            <a class="list-group-item" href="https://github.com/tomone1202">
              <small>
                <i class="fab fa-github"></i>
                Github
              </small>
            </a>
            <a href="#" class="list-group-item">
              <small>
                <i class="fas fa-phone"></i>
                0976528921
              </small>
            </a>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>